import { translations as notificationTranslations } from "./app-layout/header/notifications/translations";
import { translations as menuTranslations } from "./app-layout/menu/translations.config";
import { translations as appLayoutTranslations } from "./app-layout/translations";
import { translations as signingDocumentTranslations } from "./signing-document/translations";

export const translations = {
  ru_RU: {
    COMMON: {},
    NOTIFICATION: notificationTranslations.ru,
    MENU: menuTranslations.ru_RU,
    LAYOUT: appLayoutTranslations.ru_RU,
    SIGNING_DOCUMENT: signingDocumentTranslations.ru,
  },
  en: {
    COMMON: {},
    NOTIFICATION: notificationTranslations.en,
    MENU: menuTranslations.en,
    LAYOUT: appLayoutTranslations.en,
    SIGNING_DOCUMENT: signingDocumentTranslations.en,
  },
} as const;
